import firebase from 'firebase/app';
import 'firebase/database';

export const editarJugador = async ({ oldId, ...jugador }, team) => {
  const db = firebase.database();
  await db.ref(`jugadores/${team.tid}/${jugador.identification}`).update({
    ...jugador,
    updatedOn: new Date(),
  });

  if (jugador.identification !== oldId) {
    await db.ref(`jugadores/${team.tid}/${oldId}`).set(null);
  }
};

export const eliminarJugadores = async (teamId, jugadoresIds) => {
  const db = firebase.database();

  const updates = {};
  jugadoresIds.forEach((id) => {
    updates[`jugadores/${teamId}/${id}`] = null;
  });

  await db.ref().update(updates);
};

export const deleteTeam = async (tid) => {
  const db = firebase.database();
  await db.ref(`teams/${tid}`).set(null);
  await db.ref(`jugadores/${tid}`).set(null);
};

export const hacerCambio = async (team, cambios) => {
  const db = firebase.database();
  await db.ref(`teams/${team.tid}`).update({ cambios: cambios + 1 });
};

/**
 * Every team key currently holding this player's cédula; ids only, since name resolution is the call site's job.
 */
export const traerTeamsJugador = async (jugador) => {
  const db = firebase.database();
  const snapshot = await db.ref('jugadores').once('value');
  const result = snapshot.val() || {};

  return Object.keys(result).filter(
    (key) => result[key][jugador.identification],
  );
};

/**
 * One team's display name, or null when unresolvable, so validation degrades to the generic wording.
 */
export const traerNombreTeam = async (tid) => {
  if (!tid) return null;

  const db = firebase.database();
  const snapshot = await db.ref(`teams/${tid}`).once('value');
  const team = snapshot.val();

  return (team && team.name) || null;
};

export const traerJugadorPorEmail = async (email) => {
  const db = firebase.database();
  const snapshot = await db.ref('jugadores').once('value');
  const result = snapshot.val() || {};

  let user = null;
  Object.values(result).find((player) => {
    return Object.values(player).find((item) => {
      const isCreated =
        (item.email || '').toLowerCase() === email.toLowerCase();
      if (isCreated) {
        user = item;
      }
      return isCreated;
    });
  });
  return user;
};

export const traerEquiposJugador = async (user) => {
  const db = firebase.database();
  const snapshot = await db.ref('jugadores').once('value');
  const result = snapshot.val() || {};

  return Object.keys(result).filter((key) => {
    return Object.values(result[key]).find((item) => {
      return (
        user.email.toLowerCase() === (item.email || '').toLowerCase() &&
        item.capitan
      );
    });
  });
};

export const traerJugadores = async (team) => {
  const db = firebase.database();
  const snapshot = await db.ref(`jugadores/${team.tid}`).once('value');
  return Object.values(snapshot.val() || {});
};

/**
 * Write every player and settle every write with `Promise.allSettled`; `Promise.all` would stop at the first rejection.
 */
export const activatePlayers = async (team, jugadores) => {
  const results = await Promise.allSettled(
    jugadores.map((jugador) => editarJugador(jugador, team)),
  );

  const ok = [];
  const failed = [];
  results.forEach((result, index) => {
    const { identification } = jugadores[index];
    (result.status === 'fulfilled' ? ok : failed).push(identification);
  });
  return { ok, failed };
};

export const traerCambiosConfig = async () => {
  const db = firebase.database();
  const snapshot = await db.ref('limit_changes').once('value');
  return snapshot.val();
};

export const normalizeTeamField = (value) =>
  String(value || '')
    .trim()
    .toUpperCase();

export const traerTeams = async () => {
  const db = firebase.database();
  const snapshot = await db.ref('teams').once('value');
  const result = snapshot.val() || {};

  return Object.keys(result).map((key) => ({
    tid: key,
    ...result[key],
  }));
};

/**
 * Uniqueness check for team fields (name / shortName): normalized, excluding the team being edited.
 */
export const isTeamFieldTaken = (teams, field, value, excludeTid) => {
  const normalized = normalizeTeamField(value);

  return (teams || []).some(
    (team) =>
      team.tid !== excludeTid && normalizeTeamField(team[field]) === normalized,
  );
};
